import { render, staticRenderFns } from "./AssignPromoDropdown.vue?vue&type=template&id=5d01754d"
import script from "./AssignPromoDropdown.vue?vue&type=script&lang=js"
export * from "./AssignPromoDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports